import { takeEvery } from 'redux-saga/effects';
import { Action } from 'redux-actions';
import sagaUtility from '../../blocks/utils/saga-utility';
import ClientService from '../../services/client.service';
import { GetCardInfoActionTypes, GetClientActionTypes, GetClientCouponsActionTypes, GetClientSubsidiesActionTypes } from './types';
import { getCardInfoActions, getClientActions, getClientCouponActions, getClientSubsidiesActions } from './actions';
import ClientSubsidyService from '../../services/client-subsidy.service';
import { CardInfo } from '../../models/client/CardInfo';
import Toast from '../../components/shared/Toast';
import I18n from '../../blocks/localization';

export default function* clientSaga() {
    yield takeEvery(GetClientActionTypes.REQUEST, getClientRequest);

    yield takeEvery(GetClientCouponsActionTypes.REQUEST, getClientCouponRequest);

    yield takeEvery(GetClientSubsidiesActionTypes.REQUEST, getClientSubsidiesRequest);

    yield takeEvery(GetCardInfoActionTypes.REQUEST, getCardInfoRequest);
    yield takeEvery(GetCardInfoActionTypes.SUCCESS, getCardInfoSuccess);
}

function* getClientRequest(action: Action<any>) {
    yield sagaUtility(action.payload, ClientService.get, getClientActions.success, getClientActions.failure, false, false);
}

function* getClientCouponRequest(action: Action<any>) {
    yield sagaUtility(action.payload, ClientService.getCoupons, getClientCouponActions.success, getClientCouponActions.failure);
}

function* getClientSubsidiesRequest(action: Action<any>) {
    yield sagaUtility(action.payload, ClientSubsidyService.get, getClientSubsidiesActions.success, getClientSubsidiesActions.failure, false, false);
}

function* getCardInfoRequest(action: Action<any>) {
    yield sagaUtility(action.payload, ClientService.getCardInfo, getCardInfoActions.success, getCardInfoActions.failure);
}

function* getCardInfoSuccess(action: Action<any>) {
    const cardInfo = action.payload as CardInfo;

    if (cardInfo.isCardActive == null || cardInfo.isCardActive == undefined) {
        Toast.notifyError(I18n.t('cardNotFound'));
    }
    else if (!cardInfo.isCardActive) {
        Toast.notifyError(I18n.t('inactiveCard'));
    }
}
